<template>
    <div class="container px-0">
        <div class="px-0">
            <button id="boton-notificaciones"
                    title="notificaciones"
                    class="navbar-toggler position-relative"
                    type="button"
                    @click="showNotifications(); enableNotificationBellTracking()">
                <span class="navbar-toggler-icon">
                    <img src="/img/brand/notification_new_look.svg" alt="" />
                </span>
                <span v-if="numberNotificationUnread > 0"
                      class="position-absolute top-0 start-50 ms-2 translate-middle badge rounded-pill bg-danger fs-8">
                    {{ numberNotificationUnread }}
                </span>
            </button>
        </div>
        <!-- NOTIFICACIONES PARA PC -->
        <div class="d-none d-xl-block px-0">
<!--            <button id="boton-desktop-notificaciones" title="notificaciones" class="navbar-toggler position-relative"-->
<!--                    type="button" @click="showNotifications(); enableNotificationBellTracking()">-->
<!--                <span class="navbar-toggler-icon">-->
<!--                    <img src="/img/brand/notification_new_look.svg" alt="" />-->
<!--                </span>-->
<!--                <span v-if="numberNotificationUnread > 0"-->
<!--                      class="position-absolute top-0 start-50 ms-2 translate-middle badge rounded-pill bg-danger fs-8">-->
<!--                    {{ numberNotificationUnread }}-->
<!--                </span>-->
<!--            </button>-->
            <div class="cuerpo" :class="{ active: indexNotifications }">
                <div class="offcanvas-header d-flex justify-content-end">
                    <div
                        class="border border-secondary rounded-circle border-1 px-1 py-1 d-flex justify-content-center align-items-center">
                        <button type="button" class="btn-close" @click="showNotifications"></button>
                    </div>
                </div>
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
                        Notificaciones
                    </h5>
                </div>
                <div v-if="dataNotifications.length > 0" class="offcanvas-body pe-0">
                    <div v-for="(data, index) in dataNotifications">
                        <div class="card pe-0 opacity-0" :id="'muestraPC' + index">
                            <div class="card-body">
                                <p class="card-text truck-text-notification text-secondary text-start"
                                   :id="'alturaNotificacionPC' + index">{{ data.description }}</p>
                            </div>
                        </div>
                        <div v-if="alturaParrafoPC[index] == true"
                             @click="verNotificacion(data.id); centerDialogVisible = true; showModalNotification(index);"
                             class="card bg-gradient bg-opacity-10 border border-1 my-3 cursor-pointer pe-0"
                             :class="{ 'border-primary bg-primary': data.clients && data.clients.length > 0, 'bg-secondary': !data.clients || data.clients.length === 0 }"
                             style="width: 100%">
                            <div class="card-body text-start">
                                <div class="row">
                                    <div class="col-9 pe-0">
                                        <h5
                                            class=" truck-title-notification text-start mb-2 text-title-bat text-indigo-darkness">
                                            {{ data.title }}
                                        </h5>
                                    </div>
                                    <div class="col-3 pe-0">
                                        <p class="text-secondary">
                                            <small>{{ calculateTime(data.start_date) }}</small>
                                        </p>
                                    </div>
                                </div>
                                <p class="card-text truck-text-notification text-secondary">
                                    {{ data.description }}
                                </p>
                                <a class="card-link text-info cursor-pointer" type="text"> Ver más info </a>
                            </div>
                        </div>
                        <a v-else-if="alturaParrafoPC[index] == false && data.link != null"
                           @click="verNotificacion(data.id)" :href="data.link" type="text"
                           :target="checkOrigin(data.link)"
                           class="card text-decoration-none bg-gradient bg-opacity-10 border border-1 my-3 cursor-pointer pe-0"
                           :class="{ 'border-primary bg-primary': data.clients.length == 0, 'bg-secondary': data.clients.length > 0, }"
                           style="width: 100%">
                            <div class="card-body text-start">
                                <div class="row">
                                    <div class="col-9 pe-0">
                                        <h5
                                            class=" truck-title-notification text-start mb-2 text-title-bat text-indigo-darkness">
                                            {{ data.title }}
                                        </h5>
                                    </div>
                                    <div class="col-3 pe-0">
                                        <p class="text-secondary">
                                            <small>{{ calculateTime(data.start_date) }}</small>
                                        </p>
                                    </div>
                                </div>
                                <p class="card-text truck-text-notification text-secondary">
                                    {{ data.description }}
                                </p>
                                <a class="card-link text-info cursor-pointer" :target="checkOrigin(data.link)" id="notification-link">Ir ahora</a>
                            </div>
                        </a>
                        <div v-else-if="alturaParrafoPC[index] == false && data.link == null"
                             @click="verNotificacion(data.id)" type="text"
                             class="card bg-gradient bg-opacity-10 border border-1 my-3 pe-0"
                             :class="{ 'border-primary bg-primary': data.clients.length == 0, 'bg-secondary': data.clients.length > 0, }"
                             style="width: 100%">
                            <div class="card-body text-start">
                                <div class="row">
                                    <div class="col-9 pe-0">
                                        <h5
                                            class=" truck-title-notification text-start mb-2 text-title-bat text-indigo-darkness">
                                            {{ data.title }}
                                        </h5>
                                    </div>
                                    <div class="col-3 pe-0">
                                        <p class="text-secondary">
                                            <small>{{ calculateTime(data.start_date) }}</small>
                                        </p>
                                    </div>
                                </div>
                                <p class="card-text truck-text-notification text-secondary">
                                    {{ data.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="card bg-secondary bg-gradient bg-opacity-10 border border-1 my-3 pe-0">
                        <div class="card-body text-center">
                            <p class="card-text truck-text-notification text-secondary">
                                No tienes notificaciones pendientes
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="bgBlack" class="" @click="showNotifications"></div>
            <!-- MODAL para las notificaciones con link-->
            <el-dialog title="" :visible.sync="centerDialogVisible"
                       :width="$mq === 'sm' ? '90%' : $mq === 'xl' ? '25%' : '40%'" class="pe-0 modal-notification" center>
                <h2 class="text-title-bat text-indigo-darkness fs-5 mb-3">{{ notificacionModal.title }}</h2>
                <span class="pe-0">{{ notificacionModal.description }}</span>
                <span slot="footer" class="dialog-footer pe-0">
                    <a v-if="notificacionModal.link != null" :href="notificacionModal.link"
                       :target="checkOrigin(notificacionModal.link)" class="btn btnBlue">Conoce más</a>
                </span>
            </el-dialog>
        </div>
        <!-- /NOTIFICACIONES PARA PC -->

        <!-- NOTIFICACIONES PARA MOBILE -->
        <div class="d-block d-xl-none">
<!--            <button id="boton-mobile-notificaciones" title="notificaciones" class="navbar-toggler position-relative"-->
<!--                    type="button" @click="showNotifications(); enableNotificationBellTracking()">-->
<!--                <span class="navbar-toggler-icon">-->
<!--                    <img src="/img/brand/notification_new_look.svg" alt="" />-->
<!--                </span>-->
<!--                <span v-if="numberNotificationUnread > 0"-->
<!--                      class="position-absolute top-0 start-50 ms-2  translate-middle badge rounded-pill bg-danger fs-8">-->
<!--                    {{ numberNotificationUnread }}-->
<!--                </span>-->
<!--            </button>-->
            <div class="cuerpo" :class="{ active: indexNotifications }">
                <div class="offcanvas-header d-flex justify-content-end">
                    <div
                        class="border border-secondary rounded-circle border-1 px-1 py-1 d-flex justify-content-center align-items-center">
                        <button type="button" class="btn-close" @click="showNotifications"></button>
                    </div>
                </div>
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
                        Notificaciones
                    </h5>
                </div>
                <div v-if="dataNotifications.length > 0" class="offcanvas-body pe-0">
                    <div v-for="(data, index) in dataNotifications">
                        <div class="d-none" :id="'muestraMov' + index">
                            <div class="card-body">
                                <p class="card-text truck-text-notification text-secondary text-start"
                                   :id="'alturaNotificacionMov' + index">{{ data.description }}</p>
                            </div>
                        </div>
                        <div v-if="alturaParrafoMov[index] == true || (windowInnerWidth > 377 && data.description.length > 206) || (windowInnerWidth <= 439 && data.description.length > 180) || (windowInnerWidth <= 380 && data.description.length > 140)"
                             @click="verNotificacion(data.id); centerDialogVisible = true; showModalNotification(index);"
                             class="card bg-gradient bg-opacity-10 border border-1 my-3 cursor-pointer pe-0"
                             :class="{ 'border-primary bg-primary': data.clients.length == 0, 'bg-secondary': data.clients.length > 0, }"
                             style="width: 100%">
                            <div class="card-body text-start">
                                <div class="row">
                                    <div class="col-9 pe-0">
                                        <h5
                                            class=" truck-title-notification text-start mb-2 text-title-bat text-indigo-darkness">
                                            {{ data.title }}
                                        </h5>
                                    </div>
                                    <div class="col-3 pe-0">
                                        <p class="text-secondary">
                                            <small>{{ calculateTime(data.start_date) }}</small>
                                        </p>
                                    </div>
                                </div>
                                <p class="card-text truck-text-notification text-secondary mb-0">
                                    {{ data.description }}
                                </p>
                                <a class="card-link text-info cursor-pointer" type="text"> Ver más info </a>
                            </div>
                        </div>
                        <a v-else-if="alturaParrafoMov[index] == false && data.link != null"
                           @click="verNotificacion(data.id)" :href="data.link" type="text"
                           :target="checkOrigin(data.link)"
                           class="card text-decoration-none bg-gradient bg-opacity-10 border border-1 my-3 cursor-pointer pe-0"
                           :class="{ 'border-primary bg-primary': data.clients.length == 0, 'bg-secondary': data.clients.length > 0, }"
                           style="width: 100%">
                            <div class="card-body text-start">
                                <div class="row">
                                    <div class="col-9 pe-0">
                                        <h5
                                            class=" truck-title-notification text-start mb-2 text-title-bat text-indigo-darkness">
                                            {{ data.title }}
                                        </h5>
                                    </div>
                                    <div class="col-3 pe-0">
                                        <p class="text-secondary">
                                            <small>{{ calculateTime(data.start_date) }}</small>
                                        </p>
                                    </div>
                                </div>
                                <p class="card-text truck-text-notification text-secondary mb-0">
                                    {{ data.description }}
                                </p>
                                <a class="card-link text-info cursor-pointer" :target="checkOrigin(data.link)"
                                   id="notification-link">Ir ahora</a>
                            </div>
                        </a>
                        <div v-else-if="alturaParrafoMov[index] == false && data.link == null"
                             @click="verNotificacion(data.id)" type="text"
                             class="card bg-gradient bg-opacity-10 border border-1 my-3 pe-0"
                             :class="{ 'border-primary bg-primary': data.clients.length == 0, 'bg-secondary': data.clients.length > 0, }"
                             style="width: 100%">
                            <div class="card-body text-start">
                                <div class="row">
                                    <div class="col-9 pe-0">
                                        <h5
                                            class="truck-title-notification text-start mb-2 text-title-bat text-indigo-darkness">
                                            {{ data.title }}
                                        </h5>
                                    </div>
                                    <div class="col-3 pe-0">
                                        <p class="text-secondary">
                                            <small>{{ calculateTime(data.start_date) }}</small>
                                        </p>
                                    </div>
                                </div>
                                <p class="card-text truck-text-notification text-secondary mb-0">
                                    {{ data.description }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="card bg-secondary bg-gradient bg-opacity-10 border border-1 my-3 pe-0">
                        <div class="card-body text-center">
                            <p class="card-text truck-text-notification text-secondary">
                                No tienes notificaciones pendientes
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="bgBlack" class="" @click="showNotifications"></div>
            <!-- MODAL para las notificaciones con link-->
            <el-dialog title="" :visible.sync="centerDialogVisible"
                       :width="$mq === 'sm' ? '90%' : $mq === 'xl' ? '25%' : '40%'" class="pe-0 modal-notification" center>
                <h2 class="text-title-bat text-indigo-darkness fs-5 mb-3">{{ notificacionModal.title }}</h2>
                <span class="pe-0">{{ notificacionModal.description }}</span>
                <span slot="footer" class="dialog-footer pe-0">
                    <a v-if="notificacionModal.link != null" :href="notificacionModal.link"
                       :target="checkOrigin(notificacionModal.link)" class="btn btnBlue">Conoce más</a>
                </span>
            </el-dialog>
        </div>
        <!-- /NOTIFICACIONES PARA MOBILE -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            dataNotifications: [],
            indexNotifications: false,
            idNotification: 0,
            notificacionModal: {},
            numberNotificationUnread: 0,
            alturaParrafoPC: [],
            alturaParrafoMov: [],
            centerDialogVisible: false,
            firstLoad: true,
            windowInnerWidth: window.innerWidth
        };
    },
    mounted() {
        this.getNotifications();
        window.addEventListener('resize', (e) => {
            this.windowInnerWidth = e.target.innerWidth
        })
        // setTimeout(() => {
        //     this.checkNotificationRequestStaff()
        // }, 2000);
    },
    watch: {
        centerDialogVisible(newValue) {
            if (newValue === false) {
                let header = document.getElementById("header-bat");
                header.classList.add('sticky-top');
            }
        }
    },
    methods: {
        getNotifications() {
            axios.get(`/get-notifications`).then(({ data }) => {
                this.dataNotifications = data.notifications;
                this.$nextTick(() => {
                    this.verificacionAlturaNotificacion();
                });
                this.numberNotificationRead();
                this.checkNotificationRequestStaff()
            });
        },
        showNotifications() {
            let header = document.getElementById("header-bat");
            header.classList.toggle('sticky-top');
            this.indexNotifications = !this.indexNotifications;
            let bgBlack = document.getElementById("bgBlack");
            bgBlack.classList.toggle("offcanvas-backdrop");
            bgBlack.classList.toggle("fade");
            bgBlack.classList.toggle("show");
            axios.post('/trackingLog', {
                logName: 'notificationInApp',
                log: 'display of notifications in app is activated'
            }).then(
                ({data}) => {
                    // console.log('tracking agregado');
                })

        },
        showModalNotification(index) {
            let header = document.getElementById("header-bat");
            header.classList.remove('sticky-top');
            this.notificacionModal = this.dataNotifications[index];
        },
        numberNotificationRead() {
            this.numberNotificationUnread = 0;
            for (let i = 0; i <= this.dataNotifications.length; i++) {
                if (this.dataNotifications[i]?.clients.length == 0) {
                    this.numberNotificationUnread++;
                }
            }
        },
        verNotificacion(id) {
            this.showNotifications();
            axios.post(`/read-notification/${id}`).then(({ data }) => {
                this.getNotifications();
                this.numberNotificationRead();
            });
        },
        verificacionAlturaNotificacion() {
            this.dataNotifications.forEach((item, index) => {
                this.$nextTick(() => {
                    let alturaPCElement = document.getElementById(
                        "alturaNotificacionPC" + index
                    );
                    let alturaMovElement = document.getElementById(
                        "alturaNotificacionMov" + index
                    );
                    let muestraMov = document.getElementById(
                        "muestraMov" + index
                    );
                    let muestraPC = document.getElementById(
                        "muestraPC" + index
                    );

                    if (alturaPCElement && alturaMovElement) {
                        // Guardar el estilo original
                        let originalStylePC = alturaPCElement.style.cssText;
                        let originalStyleMov = alturaMovElement.style.cssText;

                        // Temporalmente desactivar el estilo
                        alturaPCElement.style.webkitBoxOrient = "inherit";
                        alturaPCElement.style.display = "inherit";
                        alturaPCElement.style.overflow = "inherit";
                        alturaPCElement.style.textOverflow = "inherit";
                        alturaPCElement.style.webkitLineClamp = "inherit";

                        alturaMovElement.style.webkitBoxOrient = "inherit";
                        alturaMovElement.style.display = "inherit";
                        alturaMovElement.style.overflow = "inherit";
                        alturaMovElement.style.textOverflow = "inherit";
                        alturaMovElement.style.webkitLineClamp = "inherit";

                        muestraMov.className = "card pe-0 opacity-0";
                        muestraPC.className = "card pe-0 opacity-0";
                        //console.log(muestraMov);

                        // Realizar cálculos de altura
                        let alturaPC = alturaPCElement.offsetHeight;
                        if (alturaPC > 54) {
                            this.$set(this.alturaParrafoPC, index, true);
                        } else {
                            this.$set(this.alturaParrafoPC, index, false);
                        }

                        let alturaMov = alturaMovElement.offsetHeight;
                        if (alturaMov > 70) {
                            this.$set(this.alturaParrafoMov, index, true);
                        } else {
                            this.$set(this.alturaParrafoMov, index, false);
                        }

                        // Restaurar el estilo original
                        alturaPCElement.style.cssText = originalStylePC;
                        alturaMovElement.style.cssText = originalStyleMov;
                        muestraMov.className = "d-none";
                        muestraPC.className = "d-none";
                    }
                });
            });
        },
        checkOrigin(notificationLink) {
            const currentLocationOrigin = window.location.origin
            if (notificationLink.startsWith('http://') || notificationLink.startsWith('https://')) {
                return '_blank';
            } else {
                return '_self';
            }
        },
        enableNotificationBellTracking() {
            window.dataLayer.push({
                                      'event': 'Clic Notificaciones in app'
                                  });
        },
        calculateTime(date) {
            const now = new Date();

            // Resta la fecha proporcionada de la fecha actual para obtener la diferencia en milisegundos
            const diferenciaEnMilisegundos = now - new Date(date);

            // Convierte la diferencia a minutos
            let minutosTranscurridos = Math.floor(diferenciaEnMilisegundos / (1000 * 60));
            let timeMessage = '';

            if (minutosTranscurridos <= 60) {
                timeMessage = "hace " + Math.floor(diferenciaEnMilisegundos / (1000 * 60)) + "m";
            } else if (minutosTranscurridos > 60 && minutosTranscurridos <= 1440) {
                timeMessage = "hace " + Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60)) + "h";
            } else if (minutosTranscurridos > 1440) {
                timeMessage = "hace " + Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)) + "d";
            }

            return timeMessage;
        },
        navigate(link) {
            const target = this.checkOrigin(link);

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                window.location.href = link;
            } else {
                if (target === '_self') {
                    window.location.assign(link);
                } else {
                    window.open(link, '_blank');
                }
            }
        },
        checkNotificationRequestStaff(){
            if(this.firstLoad === true && window.location.pathname === '/home-bat' && this.dataNotifications.length > 0){
                var unread_notification_staff_reject = null
                var unread_notification_staff_approved = null
                var unread_notification_staff_pending = null
                unread_notification_staff_approved = this.dataNotifications.find(item => (item.title === "Solicitud de staff aprobada!" && item.clients.length === 0));
                unread_notification_staff_reject = this.dataNotifications.find(item => (item.title === "Solicitud de staff rechazada!" && item.clients.length === 0));
                unread_notification_staff_pending = this.dataNotifications.find(item => (item.title === "Nueva solicitud de staff" && item.clients.length === 0));
                if(unread_notification_staff_approved !== null && unread_notification_staff_approved !== undefined){
                    this.$notify.success({
                                             title: 'Solicitud aprobada!',
                                             message: 'Para más información, revisa tus notificaciones.'
                                         })
                }
                if (unread_notification_staff_reject !== null && unread_notification_staff_reject !== undefined) {
                    setTimeout(() => {
                        this.$notify.error({
                                               title: 'Solicitud rechazada!',
                                               message: 'Para más información, revisa tus notificaciones.'
                                           })
                    }, 1000);
                }
                if(unread_notification_staff_pending !== null && unread_notification_staff_pending !== undefined){
                    this.$notify.warning({
                                             title: 'Solicitud nuevo usuario',
                                             message: 'Para más información, revisa tus notificaciones.'
                                         })
                }
                this.firstLoad = false;
            }
        }

    },
};
</script>
